import React, { useState } from 'react';
import ProfileAwarenessAlert, { ProfileAwarenessBadge } from './common/ProfileAwarenessAlert';
import './FoodSafetyResult.css';

function FoodSafetyResult({ result }) {
  const [expanded, setExpanded] = useState(false);

  if (!result) return null;

  const statusConfig = {
    SAFE: {
      icon: '✅',
      color: 'success',
      gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      bg: 'var(--success-light)',
      border: 'var(--success-color)'
    },
    UNSAFE: {
      icon: '❌',
      color: 'error',
      gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
      bg: 'var(--error-light)',
      border: 'var(--error-color)'
    },
    LIMITED: {
      icon: '⚠️',
      color: 'warning',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      bg: 'var(--warning-light)',
      border: 'var(--warning-color)'
    },
    UNKNOWN: {
      icon: '❓',
      color: 'info',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      bg: 'var(--info-light)',
      border: 'var(--info-color)'
    }
  };

  const status = result.safetyStatus || 'UNKNOWN';
  const config = statusConfig[status] || statusConfig.UNKNOWN;

  return (
    <div className={`food-result-modern food-result-${config.color}`}>
      <div 
        className="food-result-header"
        onClick={() => setExpanded(!expanded)}
        style={{ cursor: (result.reason || result.alternative) ? 'pointer' : 'default' }}
      >
        <div className="result-main">
          <div className="result-icon-wrapper">
            <div 
              className="result-icon"
              style={{ background: config.gradient }}
            >
              {config.icon}
            </div>
          </div>
          <div className="result-content">
            <div className="result-food-name-wrapper">
              <h3 className="result-food-name">{result.foodName}</h3>
              <ProfileAwarenessBadge 
                foodName={result.foodName} 
                ingredients={result.ingredients || []}
                type="food" 
              />
            </div>
            <div className="result-status-badge" style={{ background: config.bg, color: config.border }}>
              {result.message || 'Status'}
            </div>
          </div>
        </div>
        
        {/* Profile Awareness Alerts */}
        <ProfileAwarenessAlert 
          foodName={result.foodName}
          ingredients={result.ingredients || []}
          type="food"
        />
        {(result.reason || result.alternative) && (
          <button 
            className="expand-button"
            aria-label={expanded ? 'Collapse' : 'Expand'}
          >
            <span className={`expand-icon ${expanded ? 'expanded' : ''}`}>▼</span>
          </button>
        )}
      </div>

      {expanded && (result.reason || result.alternative) && (
        <div className="food-result-details">
          {result.reason && (
            <div className="detail-section">
              <div className="detail-header">
                <span className="detail-icon">💡</span>
                <h4>Why</h4>
              </div>
              <p className="detail-text">{result.reason}</p>
            </div>
          )}

          {result.alternative && (
            <div className="detail-section">
              <div className="detail-header">
                <span className="detail-icon">🔄</span>
                <h4>Safe Alternative</h4>
              </div>
              <p className="detail-text">{result.alternative}</p>
            </div>
          )}

          {result.notes && (
            <div className="detail-section">
              <div className="detail-header">
                <span className="detail-icon">📝</span>
                <h4>Additional Notes</h4>
              </div>
              <p className="detail-text">{result.notes}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default FoodSafetyResult;
